import styled from "styled-components";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 32px ${PAGE_GUTTER.desktop}px 48px;

  ${media.downTablet`
    padding: 24px ${PAGE_GUTTER.tablet}px 40px;
  `}

  ${media.downMobile`
    padding: 20px ${PAGE_GUTTER.mobile}px 32px;
  `}
`;

export const ContentInner = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 500px;
  text-align: left;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: #64748b;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #e8521a;
  }
`;

export const MainHeading = styled.h3`
  margin: 20px 0;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downMobile`
    font-size: 20px;
  `}
`;

export const PaymentActions = styled.div`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;

  .ant-btn {
    min-height: 44px;
    width: 100%;
  }
`;
